import PropTypes from 'prop-types';

import Link from 'bloko/blocks/link';

import useTrls from 'hooks/translation/useTrls';

import 'components/Footer/List/Links.less';

const Links = ({ links }) => {
    const trl = useTrls();

    return (
        <ul className="footer-links">
            {links.map(({ url, anchor, kind, anchorParams }, key) => (
                <li key={key} className="footer-links__link">
                    <Link href={url} kind={kind}>
                        {trl(anchor, [anchorParams])}
                    </Link>
                </li>
            ))}
        </ul>
    );
};

Links.propTypes = {
    links: PropTypes.arrayOf(
        PropTypes.shape({
            url: PropTypes.string,
            anchor: PropTypes.string,
            kind: PropTypes.string,
        })
    ),
};

export default Links;
